const _ = require("lodash");
const {
	findArguments,
	makeFormattedText,
	makeMathCommandNode,
} = require("../util/ParserHelpers");
const ColorUtil = require("../../util/ColorUtil");
const colors = ColorUtil.getDiagramColors();

const makeParser = mathMode => {
	const makeCommandNode = mathMode ? makeMathCommandNode : makeFormattedText;
	return function(ps) {
		const args = findArguments(ps, 2);
		if (!args) {
			return false;
		}
		const psList = mathMode ? args.slice(1) : args[1];
		return makeCommandNode("color", psList, {
			colorName: args[0]
				.getRest()
				.trim()
				.toLowerCase(),
		});
	};
};

const colorNode = {
	draw(rc, x, y, node, measure) {
		const context = rc.context;
		const {color} = measure;
		context.save();
		if (color) {
			context.fillStyle = color;
			context.strokeStyle = color;
		}
		rc.drawNode(rc, x, y, node.children[0]);
		context.restore();
	},
	measure(rc, fontInfo, props, node) {
		let color = colors[node.colorName];
		if (!color) {
			if (/^#[a-z0-9]{6}$/.test(node.colorName)) {
				color = node.colorName;
			} else {
				rc.pushError(node.colorName + " is not one of the available colors.");
			}
		}
		return _.extend(rc.measureNode(rc, fontInfo, props, node.children[0]), {
			color,
		});
	},
	readAloud: {children: true},
};

module.exports = {
	parsers: {
		nonmathCommands: {
			color: makeParser(false),
		},
		mathCommands: {
			color: makeParser(true),
		},
	},
	nodes: {
		color: colorNode,
	},
};
